import Enum from '../utils/Enum';

// 登录方式常量定义
export const LOGIN_TYPE = new Enum()
  .setItem('GUEST', 1, '游客')
  .setItem('PHONE', 2, '手机号码')
  .setItem('ACCOUNT', 3, '账号登录')
  .setItem('TWITTER', 4, '推特登录')
  .setItem('FACEBOOK', 5, 'facebook登录')
  .setItem('GOOGLE', 6, '谷歌登录')
  .setItem('GOOGLE_GAME', 7, 'google_game')
  .setItem('APPLE', 8, '苹果登录')
  .setItem('GAME_CENTER', 9, 'game_center')
  .setItem('HUAWEI', 10, '华为登录（海外）')
  .setItem('AMAZON', 11, '亚马逊登录')
  .setItem('QUICK_LOGIN', 12, '一键登录（极光）')
  .setItem('VK', 13, 'vk')
  .setItem('EMAIL', 14, '邮箱验证码登录')
  .setItem('CHANNEL', 20, '渠道登录(待定)');

// 公司主体常量定义
export const COMPANY_CONSTANT = new Enum()
  .setItem('DEFAULT', 0, '默认主体')
  .setItem('QC_HW', 1, '青瓷主体')
  .setItem('TAIWAN', 2, '台湾主体')
  .setItem('AUSTRALIA', 3, '澳洲主体')
  .setItem('VIETNAM', 4, '越南主体')
  .setItem('QC', 5, '厦门青瓷数码技术有限公司')
  .setItem('JAPAN', 9, '日本主体')

// 验证码类型
export const VERIFY_CODE_TYPE = new Enum()
  .setItem('PHONE', 1, '手机号')
  .setItem('EMAIL', 2, '邮箱');

// 验证码渠道
export const VERIFY_CODE_CHANNEL = new Enum()
  .setItem('REGISTER', 1, '注册')
  .setItem('RESET_PASSWORD', 2, '修改密码')
  .setItem('LOGIN', 3, '登录')
  .setItem('BIND', 4, '绑定')
  .setItem('UNBIND', 5, '解绑');

// 账号类型常量定义
export const ACCOUNT_TYPE = new Enum()
  .setItem('ACCOUNT', 'account', '账号（国内：手机，海外：邮箱）')
  .setItem('GUEST', 'guest', '游客')
  .setItem('GOOGLE', 'google', '谷歌')
  .setItem('FACEBOOK', 'facebook', '脸书')
  .setItem('GAMECENTER', 'gamecenter', 'game center')
  .setItem('APPLE', 'apple', '苹果')
  .setItem('TWITTER', 'twitter', '推特')
  .setItem('SMS', 'sms', '手机号码（海外专有）')
  .setItem('AMAZON', 'amazon', '亚马逊')
  .setItem('GOOGLE_GAME', 'google_game', '谷歌游戏')
  .setItem('HUAWEI', 'huawei', '华为登录（海外）')
  .setItem('VK', 'vk', '越南登录');

// 支付方式常量定义
export const PAYMENT_METHOD = new Enum()
  .setItem('ALIPAY', 1, '支付宝')
  .setItem('WECHAT', 2, '微信')
  .setItem('HUABEI', 3, '花呗')
  .setItem('ALIPAY_QRCODE', 4, '支付宝（扫码）')
  .setItem('WECHAT_QRCODE', 5, '微信（扫码）')
  .setItem('APPLE', 6, '苹果')
  .setItem('APPLE_STOREKIT2', 7, '苹果（StoreKit 2）')
  .setItem('GOOGLE_PAY', 8, '谷歌支付')
  .setItem('ONE_STORE', 9, 'oneStore支付')
  .setItem('HUAWEI_OVERSEAS', 10, '华为（海外）')
  .setItem('SAMSUNG', 11, '三星')
  .setItem('AMAZON', 12, '亚马逊')
  .setItem('AIRWALLEX', 13, '空中云汇')
  .setItem('THAILAND_PAY', 14, '泰国支付')
  .setItem('EUROPE_AMERICA_PAY', 15, '欧美支付')
  .setItem('TAIWAN_PAY', 16, '台湾支付')
  .setItem('SOUTHEAST_ASIA_PAY', 17, '东南亚支付')
  .setItem('VIETNAM_PAY', 18, '越南支付')
  .setItem('PAY_PAY', 19, 'payPay')
  .setItem('PAY_PAL', 20, 'payPal')
  .setItem('PAY_LETTER', 21, 'payLetter')
  .setItem('WECHAT_JSSDK', 22, '微信支付（jssdk）')
  .setItem('WECHAT_H5', 23, '微信支付（h5）')
  .setItem('ALIPAY_MOBILE_WEB', 24, '支付宝（手机网站支付）')
  .setItem('ALIPAY_PC_WEB', 25, '支付宝（电脑网站支付）')
  .setItem('ALIPAY_INTERNATIONAL_CARD', 26, '蚂蚁国际支付(antom-card)')
  .setItem('ALIPAY_INTERNATIONAL_GOOGLE', 27, '蚂蚁国际支付(antom-google)')
  .setItem('ALIPAY_INTERNATIONAL_PAYPAL', 28, '蚂蚁国际支付(antom-paypal)')
  .setItem('ALIPAY_INTERNATIONAL_APPLE', 29, '蚂蚁国际支付(antom-apple)')
  .setItem('XSOLLA_PAYPAL', 30, '欧美支付(Xsolla-paypal)')
  .setItem('ALIPAY_INTERNATIONAL', 31, '蚂蚁国际支付')
  .setItem('PAYERMAX_CARD', 33, 'PayerMax-card')
  .setItem('PAYERMAX_GOOGLE', 34, 'PayerMax-google')
  .setItem('PAYERMAX_APPLE', 35, 'PayerMax-apple')
  .setItem('ENJOYPAY_CARD', 36, 'EnjoyPay-card')
  .setItem('ENJOYPAY_APPLE', 37, 'EnjoyPay-apple')
  .setItem('ENJOYPAY_GOOGLE', 38, 'EnjoyPay-google')
  .setItem('ENJOYPAY_PAYPAY', 39, 'EnjoyPay-paypay');

// 语言常量定义
export const LANGUAGE = new Enum()
  .setItem('ZH_CN', 'zh-cn', '简体中文')
  .setItem('ZH_TW', 'zh-tw', '繁体中文')
  .setItem('EN_US', 'en-us', '英文')
  .setItem('JA_JP', 'ja-jp', '日文')
  .setItem('TH_TH', 'th-th', '泰语')
  .setItem('ID_ID', 'id-id', '印尼语')
  .setItem('VI_VN', 'vi-vn', '越南语')
  .setItem('EN_AU', 'en-au', '澳洲')
  .setItem('PT_PT', 'pt-pt', '葡萄牙语')
  .setItem('DE_DE', 'de-de', '德语')
  .setItem('FR_FR', 'fr-fr', '法语')
  .setItem('IT_IT', 'it-it', '意大利语')
  .setItem('ES_ES', 'es-es', '西班牙语')

export const PayWayImages: Record<string, string> = {
  ALIPAY: 'https://download4.qcplay.com/qcgame-api/ocmyw590hFEq1U2Oz7SIRUxLqV6NFs14DBaKxCt8.png',
  WECHAT: 'https://download4.qcplay.com/qcgame-api/6O9R0yvCeU68TMr1gV0thQCSIGC69HVXKkOQ3Bps.png',
  ALIPAY_QRCODE: 'https://download4.qcplay.com/qcgame-api/BpqnKn2HRcRGx2sfDPRHAV4tCFmPbJpkRGsBsuC1.png',
  WECHAT_QRCODE: 'https://download4.qcplay.com/qcgame-api/ojsgmKKBFqR76OmA2pAmavIUeaRqZwhKmteS9sXC.png',
  // AIRWALLEX'
  THAILAND_PAY: 'https://download4.qcplay.com/qcgame-api/SJtdIIz2tgsUqtbeeNzXo08vzii3vrfZkg6syojL.png',
  EUROPE_AMERICA_PAY: 'https://download4.qcplay.com/qcgame-admin/XBLM0tgvY7jRYoTyzQ1rhZSwD2hlqMs9LTkd1gHQ.png',
  TAIWAN_PAY: 'https://download4.qcplay.com/qcgame-api/aga9dmvrHDHGcvGLTC0pmm7OnHqe0XPlf1M5QTcz.png',
  SOUTHEAST_ASIA_PAY: 'https://download4.qcplay.com/qcgame-api/M5xS0tPr3EscbZ5aj9ycOyIHLPpB0B3l9rv36zcm.png',
  VIETNAM_PAY: 'https://download4.qcplay.com/qcgame-admin/csXmiy45JNiG4q1rvVRw9hv41CQ5IDhc2VSAR7iW.png',
  PAY_PAY: 'https://download4.qcplay.com/qcgame-api/6NJZdF9BIIYsejyOXKkhUkbBOtuaKHIYipYwIvy2.png',
  PAY_PAL: 'https://download4.qcplay.com/qcgame-api/XTAU4VlQA8U2MdTMQ1PkG6zycLhEzdVcc9yQ4wNR.png',
  PAY_LETTER: 'https://download4.qcplay.com/qcgame-api/oLfZpgXtOhd37yLjHD6nvBPqaKg9M8HJmG1Ni754.png',
  WECHAT_JSSDK: 'https://download4.qcplay.com/qcgame-api/6O9R0yvCeU68TMr1gV0thQCSIGC69HVXKkOQ3Bps.png',
  WECHAT_H5: 'https://download4.qcplay.com/qcgame-api/6O9R0yvCeU68TMr1gV0thQCSIGC69HVXKkOQ3Bps.png',
  ALIPAY_MOBILE_WEB: 'https://download4.qcplay.com/qcgame-api/ocmyw590hFEq1U2Oz7SIRUxLqV6NFs14DBaKxCt8.png',
  ALIPAY_PC_WEB: 'https://download4.qcplay.com/qcgame-api/ocmyw590hFEq1U2Oz7SIRUxLqV6NFs14DBaKxCt8.png',
  ALIPAY_INTERNATIONAL_CARD: 'https://download4.qcplay.com/qcgame-admin/XBLM0tgvY7jRYoTyzQ1rhZSwD2hlqMs9LTkd1gHQ.png',
  ALIPAY_INTERNATIONAL_GOOGLE: 'https://download4.qcplay.com/qcgame-admin/gPCmiX9EohIlBqOqFPlhmmCpVOFTblJmTi12rOsh.png',
  ALIPAY_INTERNATIONAL_PAYPAL: 'https://download4.qcplay.com/qcgame-admin/l9WU1WAWGLtFc1J7TFxvnUFQ9YDynMp5K25s9T26.png',
  ALIPAY_INTERNATIONAL_APPLE: 'https://download4.qcplay.com/qcgame-admin/3m1ye9h2ltSzjTzvR0is5oXkus7ULmBWmCC5aWOg.png',
  XSOLLA_PAYPAL: 'https://download4.qcplay.com/qcgame-api/XTAU4VlQA8U2MdTMQ1PkG6zycLhEzdVcc9yQ4wNR.png',
  ALIPAY_INTERNATIONAL: 'https://download4.qcplay.com/qcgame-admin/Qwfbj2sEpsmjKkAbPQsgMeviGrMHhOVMVp6e27ym.png',
  PAYERMAX_CARD: 'https://download4.qcplay.com/qcgame-admin/4cWuRzNHWWzQi2cWmyXYPhDMeSGz0mV2ek5RWYpC.png',
  PAYERMAX_GOOGLE: 'https://download4.qcplay.com/qcgame-admin/gPCmiX9EohIlBqOqFPlhmmCpVOFTblJmTi12rOsh.png',
  PAYERMAX_APPLE: 'https://download4.qcplay.com/qcgame-admin/3m1ye9h2ltSzjTzvR0is5oXkus7ULmBWmCC5aWOg.png',
  ENJOYPAY_CARD: 'https://download4.qcplay.com/qcgame-admin/4cWuRzNHWWzQi2cWmyXYPhDMeSGz0mV2ek5RWYpC.png',
  ENJOYPAY_APPLE: 'https://download4.qcplay.com/qcgame-admin/3m1ye9h2ltSzjTzvR0is5oXkus7ULmBWmCC5aWOg.png',
  ENJOYPAY_GOOGLE: 'https://download4.qcplay.com/qcgame-admin/gPCmiX9EohIlBqOqFPlhmmCpVOFTblJmTi12rOsh.png',
  ENJOYPAY_PAYPAY: 'https://download4.qcplay.com/qcgame-api/6NJZdF9BIIYsejyOXKkhUkbBOtuaKHIYipYwIvy2.png',
}